'use strict';

class ListOutput extends BaseComponent {
	static get defaultState() {
		return _.assign(super.constructor.defaultState, {
			updateListFn: RemoteData.getNameslist,
			btnBackEnabled: true,
			btn_back: "Nochmal eingeben",
			copy: "Vorschläge von anderen Benutzern:"
		})
	}

	constructor(element, state) {
		//init BaseComponent
		super(element, state);
		this.debug = false;
		this.state.minNameLength = 3;

		//set template id
		this._view = $('#atoms_listOutput_ListOutput').html();

		//set template props
		this._props = {
			btn_back: this.state.btn_back,
			copy: this.state.copy
		};

		//set state
		this.state.names = [];
		this.state.newName = "";

		_.bindAll(this, 'updateList');

		return this
	}

	init() {
		this.$namesList = $('.names', this.$el);
		this.$newName = $('.new-name', this.$el);
		this.$btnBack = $('.btn-back', this.$el);

		if(!this.state.btnBackEnabled) {
			this.$btnBack.removeClass('hidden');
			this.$btnBack.on('click', (evt) => {
				evt.preventDefault();
				this.$el.trigger(ComponentEvent.RESET)});
		}


		return this
	}

	updateList(input = "") {


		return this.state.updateListFn(input, (res) => {
            console.log('updateListFn', res);
			this.state.names = res.results;
			this.update();
		}, (res) => {
			//TODO ordentliche Fehlerausgabe
			console.error(res);
		});
	}

	update(force = false) {

        console.log('update');
		if (!_.isEqual(this._internalState, this.state) || force) {

			this.$namesList.empty();
			this.state.names.forEach((name) => {
				let $itm = $(`<li>${name.title}</li>`);
				this.$namesList.append($itm);
			});

			this.$newName.html(this.state.newName);
			this._internalState = _.clone(this.state);
		}

		return this;
	}
}
